import {
  Actions,
  createComposable,
  createStore,
  Getters,
  Module,
  Mutations,
} from "vuex-smart-module";
import { profileModule } from "@/store/modules/ProfileModule";
import { authModule } from "@/store/modules/AuthModule.js";
import { orderModule } from "@/store/modules/OrderModule";
import { bookmarkModule } from "@/store/modules/BookmarkModule.js";
import { checkRouteModule } from "@/store/modules/CheckRouteModule";
import { equipmentModule } from "@/store/modules/EquipmentModule";
// Import the new Pinia user store
import "@/store/user";

class RootState {
  isAuthenticated = false;
}
class RootGetters extends Getters<RootState> { }
class RootMutations extends Mutations<RootState> {
  setAuth(payload: boolean) {
    this.state.isAuthenticated = payload;
  }
}
class RootActions extends Actions<RootState, RootGetters, RootMutations, RootActions> { }
export const root = new Module({
  state: RootState,
  getters: RootGetters,
  mutations: RootMutations,
  actions: RootActions,
  namespaced: false,
  modules: {
    profileModule,
    authModule,
    orderModule,
    bookmarkModule,
    checkRouteModule,
    equipmentModule,
  },
});
export const useRoot = createComposable(root);
export const store = createStore(root);
